import { DashboardTabSection } from '@/components/Dashboard/DashboardMotion'
import { CaptacaoTab } from '@/components/Dashboard/CaptacaoTab'
import { CommissionsTab } from '@/components/Dashboard/CommissionsTab'
import { OperacaoTab } from '@/components/Dashboard/OperacaoTab'
import { PipelineTab } from '@/components/Dashboard/PipelineTab'
import { TimeTab } from '@/components/Dashboard/TimeTab'
import { mapCommissionsTabView, emptyCommissionsTabView } from '@/components/Dashboard/commissionsTab.utils'
import { mapCaptacaoTabView } from '@/components/Dashboard/captacaoTab.utils'
import { mapOperacaoSummaryData } from '@/components/Dashboard/operacaoTab.utils'
import { mapPipelineTabView } from '@/components/Dashboard/pipelineTab.utils'
import { mapTimeTabView, emptyTimeTabView } from '@/components/Dashboard/timeTab.utils'
import { mapSalesData } from '@/components/Dashboard/dashboardPageMappers'
import type { DashboardData } from '@/hooks/dashboardDataTypes'

interface DashboardTabContentProps {
  activeTab: string
  data: DashboardData
  valuesVisible?: boolean
}

export function DashboardTabContent({
  activeTab,
  data,
  valuesVisible = false,
}: DashboardTabContentProps) {
  const operacaoSummary = mapOperacaoSummaryData(data)
  const pipelineView = mapPipelineTabView(data)
  const captacaoView = mapCaptacaoTabView(data)
  const timeView = mapTimeTabView(data)
  const salesData = mapSalesData(data)
  const commissionsView = mapCommissionsTabView(data)

  if (activeTab === 'operacao' && operacaoSummary) {
    return (
      <DashboardTabSection>
        <OperacaoTab
          summary={operacaoSummary}
          monthlyTrend={salesData?.monthlyData ?? []}
          latestDeals={data.latestDeals ?? []}
          recentActivity={data.recentActivity ?? []}
          valuesVisible={valuesVisible}
        />
      </DashboardTabSection>
    )
  }

  if (activeTab === 'pipeline' && pipelineView) {
    return (
      <DashboardTabSection>
        <PipelineTab
          view={pipelineView}
          closedDeals={(data.sales?.closedDeals ?? []).map((deal) => ({
            id: deal.id,
            nome: deal.nome,
            valor: deal.valor,
            empresa: deal.empresa,
            owner: deal.owner,
            dataFechamento: deal.dataFechamento,
          }))}
          valuesVisible={valuesVisible}
        />
      </DashboardTabSection>
    )
  }

  if (activeTab === 'captacao' && captacaoView) {
    return (
      <DashboardTabSection>
        <CaptacaoTab view={captacaoView} valuesVisible={valuesVisible} />
      </DashboardTabSection>
    )
  }

  if (activeTab === 'time') {
    return (
      <DashboardTabSection>
        <TimeTab view={timeView ?? emptyTimeTabView()} valuesVisible={valuesVisible} />
      </DashboardTabSection>
    )
  }

  if (activeTab === 'comissoes') {
    return (
      <DashboardTabSection>
        <CommissionsTab
          view={commissionsView ?? emptyCommissionsTabView()}
          valuesVisible={valuesVisible}
        />
      </DashboardTabSection>
    )
  }

  return null
}
